export enum TileStatus {
  Success = 'SUCCESS',
  Failed = 'FAILURE',
  Warning = 'WARNING',
  Running = 'RUNNING',
  Queued = 'QUEUED',
  Canceled = 'CANCELED',
  Unknown = 'UNKNOWN',
  ActionRequired = 'ACTION_REQUIRED',
}

export default TileStatus
